import { CurrencyCodeType } from '@/types/currency';

export const isStablecoin = (currency: CurrencyCodeType): boolean => {
  return currency === CurrencyCodeType.USDC || currency === CurrencyCodeType.USDT;
};
